/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Disable license distribution when limit is exceeded
 * @author     Anna Morawe <anna.morawe@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

const checkboxes = document.querySelectorAll('input[type="checkbox"].js-limit-license');

const checkboxesClicked = e => {
    let _oClickedInput = e.target; // Angeklicktes input

    let _oSearchForLimit = _oClickedInput.parentElement.parentElement.parentElement.parentElement.parentElement;
    let _oLicenseLimit = _oSearchForLimit.querySelectorAll('.js-amountoflicenses')[0].textContent; // Lizenzen insgesamt für diesen Kurs
    let _oLicenseLimitAmount = Number(_oLicenseLimit);

    let _oFilterList = _oSearchForLimit.querySelectorAll('.c-filterlist__list')[0]; // Liste aller inputs für diesen Kurs
    let _oFilterItemsChecked = _oFilterList.querySelectorAll('input[type="checkbox"]:checked').length; // Insgesamt ausgewählte User für diesen Kurs

    let _oFilterItemsUnchecked = _oFilterList.querySelectorAll('input[type="checkbox"]:not(:checked)');

    if (_oFilterItemsChecked >= _oLicenseLimitAmount) {
        for (let i = 0; i < _oFilterItemsUnchecked.length; i++) {
            let item = _oFilterItemsUnchecked[i].parentElement;
            item.classList.add('is--disabled');
        }
    } else {
        for (let i = 0; i < _oFilterItemsUnchecked.length; i++) {
            let item = _oFilterItemsUnchecked[i].parentElement;
            item.classList.remove('is--disabled');
        }
    }
};

for (let input of checkboxes) {
    input.addEventListener('click', checkboxesClicked);
}
